import React, { useMemo } from "react";
import useThemeMode from "../../hooks/useThemeMode";
import { getMarketingTheme } from "../../utils/marketingTheme";
import useI18n from "../../i18n/useI18n";

const AboutStory = () => {
  const { isDark } = useThemeMode();
  const { t } = useI18n();
  const colors = useMemo(() => getMarketingTheme(isDark), [isDark]);

  const tt = (key, fallback) => {
    const value = t(key);
    return value === key ? fallback : value;
  };

  return (
    <section style={{ padding: "16px 20px 32px", background: colors.sectionBg }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
        <div
          style={{
            background: colors.cardBg,
            border: `1px solid ${colors.border}`,
            borderRadius: "28px",
            padding: "28px",
            boxShadow: colors.shadow,
            backdropFilter: isDark ? "blur(14px)" : "none",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              padding: "7px 12px",
              borderRadius: "999px",
              background: isDark ? "rgba(109,40,217,0.18)" : "#f5f3ff",
              color: isDark ? "#d8b4fe" : "#6d28d9",
              fontWeight: "700",
              fontSize: "12px",
              marginBottom: "14px",
              border: isDark ? `1px solid ${colors.border}` : "none",
            }}
          >
            {tt("about.storyBadge", "Why Hookora exists")}
          </div>

          <h2
            style={{
              margin: "0 0 14px",
              color: colors.text,
              fontSize: "clamp(2rem, 4vw, 3rem)",
              lineHeight: "1.08",
            }}
          >
            {tt("about.storyTitle", "Content creation should feel clearer, not heavier")}
          </h2>

          <div style={{ display: "grid", gap: "14px" }}>
            <p style={{ margin: 0, color: colors.textMuted, lineHeight: "1.85", fontSize: "16px" }}>
              {tt(
                "about.storyParagraph1",
                "A lot of creators know what they want to say, but still get slowed down by the wording. The hook feels weak. The title does not land. The caption feels flat. The script takes too long. That friction adds up and makes publishing harder than it should be."
              )}
            </p>

            <p style={{ margin: 0, color: colors.textMuted, lineHeight: "1.85", fontSize: "16px" }}>
              {tt(
                "about.storyParagraph2",
                "Hookora was built to reduce that friction. Instead of forcing creators to jump between scattered tools, random notes, and messy workflows, Hookora brings the process into one cleaner system that helps ideas turn into stronger outputs faster."
              )}
            </p>

            <p style={{ margin: 0, color: colors.textMuted, lineHeight: "1.85", fontSize: "16px" }}>
              {tt(
                "about.storyParagraph3",
                "Whether someone is creating from Lagos, London, or Los Angeles, the problem is often the same: content takes too much mental energy to package well. Hookora helps creators feel more supported, more consistent, and more in control of their workflow."
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutStory;